import { Component, Inject, OnInit } from '@angular/core';

import {
  CoreUtilService
} from '../../lib-services/core-util/core-util.service';

@Component({
  selector: 'project-icon',
  templateUrl: './project-icon.component.html',
  styleUrls: ['./project-icon.component.scss']
})
export class ProjectIconComponent implements OnInit {

  icon_classes: string = null;
  tooltip_content: string = null;

  constructor(
    @Inject('env') public env: any
  ) { }

  ngOnInit(): void {
    switch (this.env.product) {
      case 'KARMLY':
        this.icon_classes = 'ion-ios-briefcase';
        this.tooltip_content = CoreUtilService.project_label.capitalised;
        return;
      case 'INVOXY':
        this.icon_classes = 'ion-ios-briefcase';
        this.tooltip_content = CoreUtilService.project_label.capitalised;
        return;
    }
  }

}
